import { Component } from '@angular/core';
import { E5coreUiWorkFieldTypeListBaseComponent } from './e5core-ui-work-field-type-list-base';

@Component({
  selector: 'e5core-ui-work-field-type-list-bootstrap',
  templateUrl: './e5core-ui-work-field-type-list-bootstrap.component.html',
  styleUrls: ['./e5core-ui-work-field-type-list-bootstrap.component.css']
})
export class E5coreUiWorkFieldTypeListBootstrapComponent extends E5coreUiWorkFieldTypeListBaseComponent {
}
